<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <conciliacoes-data-table :items="items" :loading="loading" @rechargeTable="getConciliacoes()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ConciliacoesService from '@/services/ConciliacoesService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      ConciliacoesDataTable: () => import('@/components/power-ups/conciliacoes/ConciliacoesDataTable.vue')
    },
    mixins: [refreshDataMixins],

    data: () => ({
      items: [],
      loading: false
    }),

    mounted() {
      this.refreshData(this.getConciliacoes);
    },

    methods: {
      getConciliacoes() {
        this.items = [];
        this.loading = true;
        ConciliacoesService.getConciliacoes()
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
